module.exports = __webpack_public_path__ + "static/media/file-grey.63ef1882.svg";